import styled from "styled-components";
import { type FormProps } from "./form";

type WrapperProps = Pick<FormProps, "loading">;

export const Wrapper = styled("form")<WrapperProps>(({ loading }) => ({
    display: "block",
    opacity: loading ? 0.5 : 1,
    ...(loading && {
        pointerEvents: "none",
        cursor: "default",
    }),
}));
